import request from '@/router/axios';
export const getList = (row) => {
    return request({
        url: '/api/produce/out-in-stock-record/select/page',
        method: 'post',
        data: row
    })
}
